<template lang="html">
    <div class="admin-layout">

        <admin-nav></admin-nav>

        <div class="admin-layout-body" id="scroll-target">
            <app-header></app-header>
            <app-content></app-content>
        </div>

        <app-modal></app-modal>
    </div>
</template>

<script>
    import AdminNav     from './Nav.vue'
    import AppHeader    from '../app/Header.vue'
    import AppContent   from '../app/Content.vue'
    import AppModal     from '../app/Modal'

    export default {
        components: { AdminNav, AppHeader, AppContent, AppModal }
    }
</script>

<style lang="stylus" scoped>
    @import '../../assets/css/variables.styl';

    div.admin-layout {
        display: flex;

        div.admin-layout-body {
            display: flex;
            flex-direction: column;
            height: $admin-body-height;
            width: $admin-body-width;
            overflow-y: auto
            font-family: 'Muli', sans-serif
            letter-spacing: -0.4px

            &::-webkit-scrollbar { width: 0 !important }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/admin/Layout.vue